var _a, _b, _c;
export var AssignmentStatusesByFilter = (_a = {},
    _a["Scheduled" /* Scheduled */] = ["scheduled" /* Scheduled */],
    _a["Active" /* Active */] = [
        "in_progress" /* Active */,
        "not_started" /* NotStarted */,
    ],
    _a["Ended" /* Ended */] = [
        "completed" /* Ended */,
        "canceled_by_card" /* CanceledByCard */,
        "canceled_by_teacher" /* CanceledByTeacher */,
        "canceled_by_time" /* CanceledByTime */,
        "expired" /* Expired */,
        "canceled" /* Canceled */,
    ],
    _a);
export var DEFAULT_TABLE_FILTER = 'All';
export var AssignmentsTableFilters = [
    DEFAULT_TABLE_FILTER,
    "Active" /* Active */,
    "Scheduled" /* Scheduled */,
    "Ended" /* Ended */,
];
export var LabelByAssignmentsFilter = (_b = {},
    _b[DEFAULT_TABLE_FILTER] = 'All',
    _b["Active" /* Active */] = 'Active',
    _b["Scheduled" /* Scheduled */] = 'Scheduled',
    _b["Ended" /* Ended */] = 'Ended',
    _b);
export var LabelByStudentsFilter = (_c = {},
    _c["NeedIntervention" /* NeedIntervention */] = 'Need intervention',
    _c["OnTrack" /* OnTrack */] = 'On track',
    _c["NotStarted" /* NotStarted */] = 'Not started',
    _c);
